import { gql, useQuery } from '@apollo/client';
import type { CognitoUser } from '@livecontrol/scheduler/model';
import type { QueryResult } from '@livecontrol/scheduler/store';

export const QUERY = gql`
query GetUser($userId: Float!) {
  getUser(input: { id: $userId }) {
    id
    enable_email_notifications
    email
    first_name
    profile_picture
    last_name
    time_zone
    phone_number
    created_at
    updated_at 
    splashtop_email
    status {
      id
      status
    }
    command_center_access
    commandCenterAccess {
      installer_access
      id
      event_access
      device_access
      installer_management
    }
    role {
      id
      role
    }
  }
}
`;

export const useUser = (id: number): QueryResult<CognitoUser, 'user'> => {

  const { data, error, loading } = useQuery<{
    getUser: CognitoUser;
  }>(QUERY, {
    variables: {
      userId:id
    }
  });

  return { error, loading, user: data?.getUser };
};
